import { prettyAddress } from './ethereum/utils.js';

export const loadingSpinner = `
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    <span class="sr-only">Loading...</span>
`;

export function errorPopup(error) {
    console.error(error);
    $('#error-toast-body').text(error);
    new bootstrap.Toast($('#error-toast')).show();
}

export function successPopup(message) {
    console.info(`Success: ${message}`);
    $('#success-toast-body').text(message);
    new bootstrap.Toast($('#success-toast')).show();
}

export function formatTimestamp(timestamp) {
    const date = new Date(timestamp * 1000);

    return date.toLocaleDateString("en-US", {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }).replace(' at ', '<br />');
}

export function copyAddress(e) {
    const addressControl = e.currentTarget;

    navigator.clipboard.writeText(addressControl.dataset.bsOriginalTitle);

    addressControl.style.transition = '';
    addressControl.style.setProperty('color', 'green', 'important');
    addressControl.style.opacity = '0.75';
    setTimeout(function() {
        addressControl.style.transition = 'color 1s, opacity 1s';
        addressControl.style.removeProperty('color');
        addressControl.style.opacity = '1';
    }, 50);
    setTimeout(function() {
        addressControl.style.transition = '';
    }, 600);
}

export function refreshTooltips() {
    $('[data-toggle="tooltip"]').tooltip();
    $('[data-bs-toggle="tooltip"]').tooltip();
    $('.pretty-address').click(copyAddress);
}

export function auditLink(chainID, verificationReferenceID) {
    return `<a href="#" onClick="AuditRequest=window.open('${window.location.origin}/audit/?chain-id=${chainID}&verification-reference-id=${verificationReferenceID}','AuditRequest','width=450,height=560'); return false;">${prettyAddress(verificationReferenceID, false)}</a>`;
}

export default { loadingSpinner, errorPopup, successPopup, formatTimestamp, copyAddress, refreshTooltips, auditLink };
